import React from 'react'

export default {
  afangi: 5,
  forSale: true,
  viewable: true,
  btnSpan: 4,
  title: 'Áfangi 5',
  key: 'afangi-5',
  subtitle: '',
  rect: {
    className: 'bg-primary text-white',
    props: {
      transform: 'translate(1120, 774) scale(0.8)',
      width: 400,
      height: 180,
    },
  },
  path: {
    d: 'M178.1 1023.5 572.4 738l87.6 32.4 18.9-58.2h9.1v-1.9l42.4-1.4.8-2.9 176.6-6.6 1 3.6 19.2-.1 1.1-2.4 41.4-1.2 1.3-2.9 176.1-6.3.6 2.5 18.4-.6 187.1-10.6 10-77.1 26.9-1 1.7-13.5 33.1-.8.4 6.9 25.5-.3 4.2-36.5h17.4v-6.4l171.4-5.9 1.5 4.9 17.9-.5.6-4.8 113.4-3.8v-4.3h27.4v-5l28.5-.5s.5 2.9 0 3.2c-.5.3 10.4 0 10.4 0l2.5 48.3 2.2 30.3 2.1 54.9 11.4-3.9 156.2-246.4 14 1.9 3.8-4.1 43.3 7.1v5.9l21.8 3.9 12.9-10.8 26.5-43.8h1.9l2.5-4.9 129.3 19.6 1.5-2.6 27.9 4.7v11.1l6.4.9-241.3 475.3-.4 102.2-691.5 30.8-.6 4.5-83.1 3.4-49.1-5.3-52.9 1.4-1.9-8.8-51.1 1.6.3-4-445.1 15.1-2.2 6.8-91 3.3-3.2 10.2-42.9-1.2-20.5 60.8-165.1 3.1-190.8-83.8z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/skogarhverfi/cam06c.jpg'),
      width: 3472,
      height: 1953,
    },
    list: [
      {
        lod: 'laufskogar-15',
        d: 'm2752.6 1252-35.5-1-.5-4.9-217.5-1.3-69.6-3.7-158.6-3.2 15.9 106.3 19.2 11.9 140.7 1.1 151.5 9.8 170.8 1.3-26.3-86.7z',
      },
      {
        lod: 'laufskogar-11',
        d: 'M1603.2 1207.2h-108.6l-21.9 118.9 102 2.3 19.5-14.3 10.4-104.6.3-2.7z',
      },
      { lod: 'laufskogar-9', d: 'm1384 1207.2-26 117 114.7 1.9 21.9-118.9z' },
      {
        lod: 'laufskogar-8',
        d: 'm3397 1480.3 2.7-37-89.8-22.5-10.6-16.7-523.3-6.2 49.7 162.6 614.6 5.2z',
      },
      { lod: 'laufskogar-7', d: 'm1384 1207.2-44.6-2.7-67.9-3.1-26.3 121.9 112.8.9z' },
      {
        lod: 'laufskogar-6',
        d: 'm2776 1397.9-159.4-2.2-71.1-4.5-50.3-1.3-31.6-4.3-66.1-1-78.6-1.1-103.1 1.9 5.1 36.4-28.2.1 7.8 132.5 625.2 6.1z',
      },
      { lod: 'laufskogar-5', d: 'm1163.5 1201.4-34.2 120.6 115.6 1.2.3.1 26.3-121.9z' },
      {
        lod: 'laufskogar-4',
        d: 'm1873.6 1381.9-.2-23.9-547-4.9-6.5 34.4 24.9 1.6L1318 1510l399.1 5 .6 12.7 104.2 1.3v15.5l91.2 1.7 1.3-162.8z',
      },
      { lod: 'laufskogar-3', d: 'm1163.1 1201.4-110.3 3.1-41.2 112.7 117.7 4.8 34.2-120.6z' },
      {
        lod: 'laufskogar-2',
        d: 'm1319.9 1387.5 6.5-34.4-222.3-5.9-53.9-2.3-217.6-1.8-14 32.8h-46.2l-64.7 151.3 45.1.7 3.9-12.6 156.9 2.1 6.6-16.2 397.8 8.8 26.8-120.9z',
      },
      {
        lod: 'laufskogar-1',
        d: 'm1003.6 1181.1-31.7 22.3h-9.4l-3 8.1-64.7 44.4-18.3 59.2 135.1 2.1 41.2-112.7z',
      },
      {
        lod: 'blaskogar-13',
        d: 'm1808.2 1213.6-91.8-.9v14l-54.9 1.2-7.8 88 1.6 2.3 2.9 2.6 2.8 2 3.8 2.1 5.2 1.8 4.4 1.3 170.3 1.3.9-106h-37.4z',
      },
      {
        lod: 'blaskogar-11',
        d: 'M1847.6 1131.4v-.5h-37.7v-8.9H1722v8.9l-53.1-1.4-7.4 98.4 54.9-1.2v-14l91.8.9v9.7h37.4z',
      },
      {
        lod: 'blaskogar-9',
        d: 'M1722 1122h87.9v8.9h37.7l4.4-93.8-132.9-2-41.5 24.5-8.7 69.9 53.1 1.4z',
      },
      {
        lod: 'blaskogar-7',
        d: 'M1682.2 964.7v-5.4l-286.5-2.5-1.1 4.1-70.3-.2-.6 4.2h-18.9l-27.5 98.7 377.6-.9 47.4-24.3 4-73.3z',
      },
      {
        lod: 'blaskogar-6',
        d: 'M1602.8 1092h-5.3l-.8-3.7-211.8-1.4-.9 7.7-19.4.2-25.2 109.7 44.6 2.7h219.2l1.7-.4 12.5-105.6z',
      },
      {
        lod: 'blaskogar-5',
        d: 'M1290.9 964.8v-8l-286.3-2.4-1.5 4.4h-68.9l-1 2.5-15.3-.6-31.1 80.7 17.5 18 373 4.2 27.5-98.7z',
      },
      {
        lod: 'blaskogar-4',
        d: 'M1364.6 1094.8h-16.7l.3-6.8-4.4.1-.1-3.1-263.7-1.2-2.4 8.9-18.2.2h-.9l-17.1 57.1-37.8 31.1 49.2 23.4 110.3-3.1h108.4l67.9 3.1z',
      },
      { lod: 'blaskogar-3', d: 'm872.8 1047-128.3-53.1-325.7 206.6 170.3 82.6 308.5-212.3z' },
      {
        lod: 'blaskogar-2',
        d: 'm959.5 1211.5 3-8.1h9.4l31.7-22.3 37.8-31.1 17.1-57.1-54.7-.8-44-19.2-24.5 17.7-3.4.7-8.9 2-7.6 1.6-7.2 2.1-6.4 3.3-6.2 4-249.9 171.9v18l6.6 2.9 9.4 3.8 11.8 4.1 10 3.6 11.2 3 11.8 2.3 170 1.2 18.3-59.2z',
      },
      { lod: 'blaskogar-1', d: 'M418.8 1200.5 23.9 1450.4l177.7 92.6 386.2-259 1.3-.9z' },
      {
        lod: 'barkaskogar-1',
        d: 'm249.1 1576.1 31.7-22.1 22.1-19.7 129.5-120.7 120.9-82.3 10.6-6.8 7.6-3.5 9.9-3.7 8.2-1h9.7l8.3 1.3 6.3 3.1 61.8 1.1 5.4 18.6 29.2 2.4-2.2 11.8 10.1 7.8-1.6 4.5h24.3l-107.5 253.3h-33.5l-19.1 12.4-247.7-3.7z',
      },
      {
        lod: 'jokuskogar-2',
        d: 'm2190.2 1403.8-79-17.3-2-34h-66.4l-1.3 17.7-17.9-3.1h-15.9l-9.5 1.9 4 212.4 21.5.6v-15.3l131 1.4-.9-14.7 45.9 1h.8l-7.8-132.5z',
      },
      {
        lod: 'kjarrskogar-9',
        d: 'm2768.8 802.1 1.9-10.7-11-27-45.4.8-1.5 6.7h-41.6l-1.3 4-181.5-1.3-.7 10.6h-22.2l19 80.8 209.6 1.5 47.4-16.3 47.4.8z',
      },
      {
        lod: 'kjarrskogar-8',
        d: 'm2822 935.5.4-5.8-17.4-40.5-80.5-.8v3.7h-58.4l30.3 90 143.8 1.1z',
      },
      {
        lod: 'kjarrskogar-7',
        d: 'm2459.8 785.2-2.1-10.9-276.2-2.4-.5 11.4-38.9-.3 6 66.4 25.7 14.2 310.7 2.4-19-80.8z',
      },
      {
        lod: 'kjarrskogar-6',
        d: 'M2695.2 982.1h1.2l-30.3-90h-4.7l-.7-4.1-80.3-.4-.9 3.8-60.2-.4 22.2 90.1z',
      },
      {
        lod: 'kjarrskogar-5',
        d: 'm2179.5 975.4-51.1.5-.2-2h-55.7l-.1 1.3-60.6-1.3-3.7-128.8h52.5l1.2-23.2h53.3l.8 13 29.4.3.6 19.8 21.3 10.9z',
      },
      { lod: 'kjarrskogar-4', d: 'm2519.3 891-5.7-.2-1.8-5H2432l-.3 4.2h-59.3l17.7 89.1 151.4 2z' },
      {
        lod: 'kjarrskogar-3',
        d: 'm2080.4 1168.2 83.7 1.3v11.6h38.8l-19.3-177.9-21.5-.5s-.4-15.8-.6-15.8c-.2 0-32.8-4.3-32.8-4.3l-.6-8.6h-55.8l-1.5 28.3-56-.5 8.5 180.1 56.2-.8.9-12.9z',
      },
      {
        lod: 'kjarrskogar-2',
        d: 'm2372.4 890-12.4-.1-.5-3.8h-80.6l-.2 2.6h-35.8l-7.2 1-6.8 2.7-3.6 3.8-1.4 4.8s.2 5.9 0 6.2c-.2.3 10.8 71 10.8 71l155.4.8-17.7-89z',
      },
      {
        lod: 'kjarrskogar-1',
        d: 'M2203 1181h-38.8v-11.6l-83.8-1.2-.8 12.8-56.2.8 6.7 142.3 111.8 24 22.6 4.4 20.7 1.8 14.5.5 8.2-.9 7.4-4.1 5.4-5.4 3.2-4.7v-9.2z',
      },
      {
        lod: 'klapparskogar-9',
        d: 'm2979.5 1064.3-123-29.5-33.8 98.1 26.3 6.7 70.8 16.2-.6 2.4 37.3 8.8 22.2-5 23.5-90.4z',
      },
      {
        lod: 'klapparskogar-7',
        d: 'm2856.5 1034.8-24.3-5.3 1.5-4.4-85.5-18.6-1.6 3.6-5.5-1.2-59.6.1 32.6 98.1 17.2.9 91.4 24.9 33.8-98.1z',
      },
      {
        lod: 'klapparskogar-5',
        d: 'm2681.5 1009-64.7-1.2-1.9-7.2-28.4-.2-1 7.4-50.9-.8 25.7 99 153.2 1.1h.6z',
      },
      { lod: 'klapparskogar-3', d: 'M2534.6 1007H2469l-.6-5-29-.2-.7 4.2-51.1.1 20.9 99 151.8.9z' },
      {
        lod: 'klapparskogar-2',
        d: 'm2499.1 1244.8 217.5 1.3.5 4.9 35.5 1 31.5-94.5-.4-.1-45.1-13.8-4.5-11.9-429.4-4-.5 8.3h-33.7l-13.6 13.1 14 88.8 158.6 3.2z',
      },
      {
        lod: 'klapparskogar-1',
        d: 'm2387.6 1006.1-58.4-.1.2-5.4-29.6-.6-1.2 5h-60.8l9.9 69.2 1.1 8.7 1.8 6.5 3.6 4.8 3.6 3.2 5.1 3.1 7 2.6s6.6 1.1 6.8 1.1 130.7.9 130.7.9h.9l-20.7-99z',
      },
      {
        lod: 'tjarnarskogar-15',
        d: 'm3133.8 630.5 16-60 20.3 3.4 3.9-13.6 129.9 22.5.8-3.7 87.7 14.5 1.2-3.7 44.5 8.3-1 22.3 2.8.4-6 63.7-18.2.4-227-42.1-17.8-3.3-10.5-.5-10.7.6-6.1.7z',
      },
      {
        lod: 'tjarnarskogar-13',
        d: 'm3122.6 644.9-35.5-6.2 2.8-12.5-73.1-14.2-4.7 12.2-32-5.5-20.1 53.1-.2.6 36.5 6.9 3.6-11.9 73.7 14.4-1.4 11.1 29.9 5.4c1.7-6.8 10.6-42.2 10.6-42.5.1-.4 9.9-10.9 9.9-10.9z',
      },
      {
        lod: 'tjarnarskogar-11',
        d: 'm2978.6 733.8 5.2-13.5 74.7 16-1.8 11.7 30.2 7.1 14.9-55.6s.1-.4.3-1.1l-29.9-5.4 1.4-11.1-73.7-14.4-3.6 11.9-36.5-6.9-18.5 53.5-.1.5 37.4 7.3z',
      },
      {
        lod: 'tjarnarskogar-9',
        d: 'm3056.7 747.9 1.8-11.7-74.6-16-5.3 13.6-37.4-7.5-19.3 60.9 32.9 7.7 6.3-18.4 77.3 16-3.5 17.1 35.3 7.8 16.7-62.4z',
      },
      {
        lod: 'tjarnarskogar-7',
        d: 'm3070.2 817.4-35.3-7.8 3.5-17.1-77.3-16-6.3 18.4-32.9-7.7-21.5 60.4 34.4 7.2 6.7-18.1 79.3 17.3-3.4 17 36.1 8.6z',
      },
      {
        lod: 'tjarnarskogar-6',
        d: 'm3429.5 712.8-14.9-3.6 1.1-24.2-195.4-34.7-4.6 19.2-25.9-4.5-40.5 171.8 23.3 5.7 1.5-7.1 219.1 44.2v7.6l17.9 3.8z',
      },
      {
        lod: 'tjarnarskogar-5',
        d: 'm3053.5 879.6-36.1-8.6 3.4-17-79.3-17.3-6.7 18.1-34.4-7.2-21.3 63.4 38.9 9.3 6.1-18 81.3 17.9-2.4 17.1 32.9 8z',
      },
      {
        lod: 'tjarnarskogar-4',
        d: 'm3393.2 879.6-219.1-44.2-1.5 7.1-23.3-5.7-43.6 199.5 283 61.2 22.4-206.5-17.9-3.8z',
      },
      {
        lod: 'tjarnarskogar-3',
        d: 'm3005.4 920.2-81.3-17.9-6.1 18-38.9-9.3-23.9 66.1 161.6 40.2 19.1-72-32.9-8z',
      },
      { lod: 'tjarnarskogar-2', d: 'm3361.1 1367.4-314.9-3-13.4-14.5 62.9-276.2 289.4 64.2z' },
      {
        lod: 'tjarnarskogar-1',
        d: 'm2964.4 1211.4-15.8-16.2-36.2-10.3 7.4-29.1-70.8-16.2-4.1 12.8-19.7-5-6.1 17.7-35-7.6-41.4 124.1 26.3 86.7 173.7 2.4 17.2-12.1-21.3-49.8z',
      },
    ],
  },
}
